





































import Vue from 'vue'
import { vehicleSpriteMappings } from '~/constants/sprite/vehicle'

export default Vue.extend({
  props: {
    category: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      vehicleIcon: vehicleSpriteMappings[this.category.category.name]
    }
  },
  computed: {
    title() {
      const name =
        this.category.count > 1
          ? this.category.category.humanNamePlural
          : this.category.category.humanName
      return `${this.category.count} ${name}`
    }
  }
})
